/**
 * Responsive catalog menu v2 for header-2.
 * Keeps the legacy mobile menu and its script available as a fallback.
 */

document.addEventListener('DOMContentLoaded', function() {
  const burger = document.querySelector('.header .burger');
  const mobileMenu = document.querySelector('.header__nav-mobile-v2');
  const desktopMenu = document.querySelector('.desktop-menu-v2');

  if (desktopMenu) {
    const categoryButtons = Array.from(desktopMenu.querySelectorAll('[data-menu-panel]'));
    const productPanels = Array.from(desktopMenu.querySelectorAll('[data-menu-products]'));

    const activateDesktopPanel = function(panelName) {
      categoryButtons.forEach(function(button) {
        button.classList.toggle('is-active', button.dataset.menuPanel === panelName);
      });

      productPanels.forEach(function(panel) {
        panel.classList.toggle('is-active', panel.dataset.menuProducts === panelName);
      });
    };

    categoryButtons.forEach(function(button) {
      const activate = function() {
        activateDesktopPanel(button.dataset.menuPanel);
      };

      button.addEventListener('mouseenter', activate);
      button.addEventListener('focus', activate);
      button.addEventListener('click', activate);
    });
  }

  if (!burger || !mobileMenu) return;

  const groups = Array.from(mobileMenu.querySelectorAll('.mobile-menu-v2__group'));

  burger.setAttribute('role', 'button');
  burger.setAttribute('tabindex', '0');
  burger.setAttribute('aria-label', 'Open menu');
  burger.setAttribute('aria-expanded', 'false');

  burger.addEventListener('click', function(e) {
    e.stopPropagation();

    if (mobileMenu.classList.contains('is-open')) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  });

  burger.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      burger.click();
    }
  });

  groups.forEach(function(group) {
    group.addEventListener('toggle', function() {
      if (!group.open) return;

      groups.forEach(function(otherGroup) {
        if (otherGroup !== group) otherGroup.open = false;
      });
    });
  });

  document.addEventListener('click', function(e) {
    if (
      mobileMenu.classList.contains('is-open') &&
      !mobileMenu.contains(e.target) &&
      !burger.contains(e.target)
    ) {
      closeMobileMenu();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
      closeMobileMenu();
    }
  });

  function openMobileMenu() {
    mobileMenu.classList.add('is-open');
    burger.setAttribute('aria-label', 'Close menu');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    mobileMenu.classList.remove('is-open');
    burger.setAttribute('aria-label', 'Open menu');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';

    groups.forEach(function(group) {
      group.open = false;
    });
  }
});
